<template lang="pug">
  footer.footer
    img.footer__logo(src="~@/assets/logo-horizontal.png", alt="Villa Blanca Логотип")
    .container
      .row
        .col-xs-12.col-lg-offset-1.col-lg-10
          nav.footer__navigation.navigation
            .navigation__item
              a.navigation__link.text-small.js-scroll(href="#fizzy") Коллекция Villa Blanca
            .navigation__item
              a.navigation__link.text-small.js-scroll(href="#taste-secrets") Секрет вкуса 
            .navigation__item
              a.navigation__link.text-small.js-scroll(href="#lifestyle") Жизнь в стиле Villa Blanca 
            .navigation__item
              a.navigation__link.text-small.js-scroll(href="#features") Почему Villa Blanca
            .navigation__item
              a.navigation__link.text-small.js-scroll(href="#feedback") Контакты
          .footer__info
            a.footer__link(href="/policy.pdf", title="Политика обработки персональных данных", target="_blank") Политика обработки персональных данных
            .footer__copyright © OOO «ЦПИ-Ариант» {{ currentYear }}
          .footer__disclaimer 
            | Чрезмерное 
            | употребление 
            | алкоголя 
            | вредит 
            | вашему 
            | здоровью
</template>

<script>
import Navigation from "./Navigation.vue";

export default {
  name: "Footer",
  components: {
    Navigation
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.footer {
  background: $color-background--contrast;
  padding-bottom: 15%;

  @include from("xl") {
    padding-bottom: 6%;
  }
  @include from("xxxl") {
    padding-bottom: 2%;
  }
  &__logo {
    margin: auto;
    display: block;
    transform: translateY(-20%);
    max-width: 100%;
  }
  &__info {
    font-size: 14px;
    line-height: 1.3;
    color: $color-text--contrast;
    mix-blend-mode: normal;
    opacity: 0.8;
    display: flex;
    justify-content: space-around;
    flex-flow: row wrap;

    @include from("xxxl") {
      font-size: 20px;
    }
  }
  &__link {
    text-decoration: none;
    color: $color-text--contrast;
    transition: $links-hover-transition;

    &:hover {
      text-decoration: underline;
    }
  }

  &__navigation {
    .navigation__link {
      font-weight: normal;
      transition: $links-hover-transition;
      &:after {
        display: none;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__disclaimer {
    text-align: center;
    text-transform: uppercase;
    color: $color-text--contrast;
    opacity: 0.15;
    padding: 20px 0;
    font-size: 51px;
    line-height: 1;
    font-family: $font-cera-pro;
    transform: scale(0.45, 1.2);
    width: calc(100% / 0.45);
    transform-origin: top left;

    @include from("xl") {
      font-size: 62px;
    }
    @include from("xxxl") {
      font-size: 81px;
    }
  }
}
</style>
